// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__ZmYOT"};